import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Pagination, Radio, Row, Select, Space, Table, Tabs } from 'antd';
import { Badge } from 'flowbite-react';
import React, { useState } from 'react';
import { Link, useLoaderData, useNavigate, useParams } from 'react-router-dom';
import GoBack from '../../../globalComponents/GoBack';

const columns = [
  {
    title: 'Reference',
    dataIndex: 'number',
    key: 'number',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'From',
    dataIndex: 'from',
    key: 'from',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'To',
    dataIndex: 'to',
    key: 'to',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Contact',
    dataIndex: 'contact',
    key: 'contact',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white'
  },
  {
    title: 'Scheduled Date',
    dataIndex: 'schedule_date',
    key: 'schedule_date',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <span>{new Date(record.schedule_date).toUTCString()}</span>
  },
  {
    title: 'Source Document',
    dataIndex: 'source_document',
    key: 'source_document',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    render: (_, record) => <Badge className={record.status === 'waiting' ? "text-blue-600 bg-blue-100 w-max" : record.status === 'done' ? "text-green-950 bg-green-100 w-max" : record.status === 'draft' && "text-slate-950 bg-slate-100 w-max"}>{record.status}</Badge>

  },
  {
    title: 'Action',
    key: 'operation',
    fixed: 'right',
    width: 100,
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
    render: (_, record) => (
      <Link className='h-full w-full' to={'/inventory/transfers/'+record.number.replaceAll('/', '-')}>
        EDIT
      </Link>
    )
  }
]



const StockRequestTransfers = () => {
  const transfers = useLoaderData();
  const navigate = useNavigate();
  const params = useParams();

  const onRow = (record, rowIndex) => {
    return {
      onClick: () => navigate('/inventory/stock-request/'+params.id+'/transfers/'+record.number.replaceAll('/', '-'))
    };
  }

  return (
    <div>
      <div className='flex justify-between mx-4'>
        <h3 className='font-bold'><GoBack /></h3>
        <div className=' bg-white dark:bg-gray-900'>
          {/* <Input addonBefore={<MdFilterAlt />}  defaultValue="mysite" /> */}

          <Select
            mode='multiple'
            size={'middle'}
            placeholder='Filter'
            // defaultValue={['a10', 'c12']}
            // onChange={handleChange}
            className='w-96'
            options={[]}
          />
        </div>
      </div>
      <div className='columns-2 mx-4 my-2'>
        <div className='column'>
         <span></span>
        </div>
        <div className='dark:bg-gray-900 column'>
          <div className='flex justify-end'>
            <Pagination  total={50} />
          </div>
        </div>
      </div>
      <Table
        sticky
        key={'number'}
        onRow={onRow}
        rootClassName='hover:cursor-pointer'
        dataSource={transfers}
        columns={columns}
        scroll={{ x: 1500 }}
        pagination={false}
      />
    
    </div>
  )
}

export default StockRequestTransfers;